var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "grid grid-cols-1 md:grid-cols-12 gap-4 sm:gap-6 md:gap-8 py-2 rounded-full sm:py-4 md:py-6 md:pb-8",
    },
    [
      _c(
        "div",
        { staticClass: "md:col-span-4 space-y-4 sm:space-y-6 md:space-y-8" },
        [_vm._t("primary")],
        2
      ),
      _c(
        "div",
        { staticClass: "md:col-span-8 space-y-4 sm:space-y-6 md:space-y-8" },
        [_vm._t("secondary")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }